export function makeScroll(el, options) {
  const isSmoothScrollSupported =
    "scrollBehavior" in document.documentElement.style;

  const isScrollBySupported = el.hasOwnProperty("scrollBy");

  if (isSmoothScrollSupported) {
    el.scrollBy(options);
  } else if (isScrollBySupported) {
    el.scrollBy(options.left, options.top);
  } else {
    el.scrollLeft = el.scrollLeft + options.left;
  }
}

export function includeCss(id) {
  const idStr = id.toString();

  const url = `//jsn.24smi.net/${idStr[0]}/${idStr[1]}/${idStr}.css`;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.media = "all";
  link.href = url;

  const head = document.getElementsByTagName("head")[0];
  head.appendChild(link);
}
